// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4848) return "static/chunks/4848-a951ec7fb0cb99f0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"618":"b8bfd8c1757bf87c","4748":"c9008f2bee665b81","7398":"a9f3cb2b200d33a9","7552":"b75a9d1c35285479"}[chunkId] + ".js";
};